module.exports = __webpack_public_path__ + "static/media/Montserrat-Regular.90767c9c.woff2";